class AppFooter extends Component {
	constructor(el) {
		super(el);
        this.buttonUp = this.$find('[data-buttonUp]');

		this.addEventListeners();
	}

    addEventListeners() {
		this.buttonUp.addEventListener('click', () => window.scrollTo(0, 0));
	}

}